module.exports = __webpack_public_path__ + "static/media/brego3590.bfd9ac34.jpg";